import { render, staticRenderFns } from "./PopupAmendments.vue?vue&type=template&id=74ce1b7c&scoped=true&"
import script from "./PopupAmendments.vue?vue&type=script&lang=js&"
export * from "./PopupAmendments.vue?vue&type=script&lang=js&"
import style0 from "./PopupAmendments.vue?vue&type=style&index=0&id=74ce1b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ce1b7c",
  null
  
)

export default component.exports